import React, { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Stimulation.module.css';
import { ResponsiveContainer } from 'recharts';
import Grid from '@mui/material/Grid';
import { Box, Typography } from '@mui/material';
import GraphHeader from '../../../pages/Stim/graphHeader';
import Hormonalgraph from '../../../pages/Stim/hormonalgraph';
import FollicularGraph from '../../../pages/Stim/follicularGraph';
import { usePatientContext } from '../../SubPatinetProvider';
import { StimulationSchedular } from '../../stimSchedular';
import {ReactComponent as CycleSVG} from '../../../assets/SVG/In vitro fertilization-bro 1.svg';
import { getButtonStates } from '../../../utils/permissionService';
import NoAccessPage from '../../../pages/noAccessPage';

interface StimulationProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  stimulationChart?: any;
}


const Stimulation: React.FC<StimulationProps> = ({ stimulationChart }) => {
  const { t } = useTranslation('cycleOverview_config');


  const [graphType, setGraphType] = useState<'follicular' | 'hormonal'>('follicular');
  const [selectedSide, setSelectedSide] = useState<'left' | 'right'>('right');
  const [hideLegend, setHideLegend] = useState(false);
  const {patientId} = usePatientContext();
  const { canView: canViewGraph } = getButtonStates('Clinical', 'Stimulation', 'Follicular Graph', 'female');
  const { canView: canViewChart } = getButtonStates('Clinical', 'Stimulation', 'Chart', 'female');

  if (!canViewGraph && !canViewChart) {
    return (
      <NoAccessPage/>

    );
  }

  return (
    <><div className={styles.container}>
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent="center" alignItems="center">
          {canViewGraph ? (
            <ResponsiveContainer width="100%" >

              <Suspense fallback={<Typography>{t('LoadingGraph')}</Typography>}>
                <GraphHeader
                  graphType={graphType}
                  setGraphType={setGraphType}
                  selectedSide={selectedSide}
                  hideLegend={hideLegend}
                  setSelectedSide={setSelectedSide} />
                <Box className={styles.scheduler}>
                  {graphType === 'hormonal' ? <Hormonalgraph patientId={patientId} stim={Number(stimulationChart)} /> : <FollicularGraph patientId={patientId} stim={Number(stimulationChart)} onHideLegend={setHideLegend} />}
                </Box>
              </Suspense>
            </ResponsiveContainer>
          ) : (
            <NoAccessPage message={t('NoGraphAccess')} />

          )}
        </Grid>
      </Grid>
    </div><div className={`${styles.container} mt-4`} >
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container justifyContent="center" alignItems="center">
          {canViewChart ?(
            <ResponsiveContainer width="100%" >
              <Suspense fallback={<Typography>{t('LoadingChart')}</Typography>}>
                <div className={styles.scheduler}>
             
                  {stimulationChart ? <StimulationSchedular id={stimulationChart} isEdit={false} height={'50vh'}/> : <div className={styles.logo}><CycleSVG/><Typography variant='h6'>{t('NoActiveStimCycleFound')}</Typography></div>}
                </div>
              </Suspense>
            </ResponsiveContainer>
          ):(
            <NoAccessPage message={t('NoChartAccess')} />
          )}
        </Grid>


      </Grid>
    </div></>
  );
};

export default Stimulation;
